// removed by extract-text-webpack-plugin
module.exports = {"container":"_3gp9X3msP4qplgcehNgElk","title":"_3zW9J8ZYi5USCGPdgShr7R","notact":"_2hBq_xS-D-gN9Mn_6XEyaC","inactiva":"_28LNnq2SUpQ8-4cTirOMsI","activa":"_2roetWaoORLChZhG8dc_P7"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Settings/State/styles.css
// module id = 2653
// module chunks = 0